module.exports = __webpack_public_path__ + "img/top_banner.7e30595b.png";